import React, { forwardRef } from 'react';
import { Box as MuiBox, BoxProps as MuiBoxProps } from '@mui/material';
import { SxProps } from '../../utils';

export interface BoxProps extends MuiBoxProps {
  /**
   * The component used for the root node. Either a string to use a HTML element or a component.
   * @default div
   */
  component?: React.ElementType;
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx?: SxProps;
}

export const Box = forwardRef<HTMLDivElement, BoxProps>(function Box({ ...props }, ref) {
  return <MuiBox {...props} ref={ref} />;
});
